import { isEmpty } from 'lodash';
import React, { useEffect, useState } from 'react';
import { Modal } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import * as action from '../store/DevelopmentOrder.action';
import Loader from '../../../Components/Utility/Loader/Loader';

function ForPreview({ onOpen, toggle, devOrderId, reportId, fromTestLib, showData, bomComp, fromArchive, colourComp, supplierComp }) {
  const dispatch = useDispatch();
  const { t } = useTranslation('common');
  const ProductTestingData = useSelector((redState) => redState);
  const { Measuremets } = ProductTestingData;
  const { previewData, testingAttributes } = Measuremets;
  console.log('🚀 ~ ForPreview ~ previewData:', previewData);
  const [loading, setLoading] = useState(false);
  const ifSupplierIsId = () => {
    return supplierComp !== null ? supplierComp : null;
  };

  const fromTestingLibrary = async () => {
    if (!showData?.pdf) {
      const paramsforBomFilter = {
        testLib: showData?._id,
        bomComponent: bomComp?._id ? bomComp?._id : null,
        colour: colourComp?._id ? colourComp?._id : null,
        supplier: supplierComp?._id ? supplierComp?._id : ifSupplierIsId(),
      };
      await dispatch(action.getDocument(paramsforBomFilter));
    }
  };

  useEffect(() => {
    const init = async () => {
      if (!fromTestLib) {
        const getParams = {
          reportId: reportId || 'noFile',
        };
        setLoading(true);
        const reponse = await dispatch(action.forPreviewReport(getParams, devOrderId));
        if (reponse) {
          setLoading(false);
        }
      } else {
        fromTestingLibrary();
      }
    };
    if (devOrderId) {
      init();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fromTestLib, devOrderId, reportId, showData?._id]);

  const renderingData = () => {
    const pdfPath = showData?.testReport?.pdf || showData?.pdf;
    if (fromTestLib) {
      if (!pdfPath) {
        return (
          !Array.isArray(testingAttributes) && (
            <iframe title={t('DEVLOPMENT_ORDER.TESTING.FOR_PREVIEW.PREVIEW_FRAME')} className="w-100 preview-modal-height" src={testAttri()} />
          )
        );
      }
      return (
        <iframe
          title={t('DEVLOPMENT_ORDER.TESTING.FOR_PREVIEW.PREVIEW_FRAME')}
          className="w-100 preview-modal-height"
          src={(!isEmpty(showData?.pdf) || showData?.pdf !== null) && `${showData?.pdf}`}
        />
      );
    }
    return previewData && !isEmpty(previewData) ? (
      <iframe
        title={t('DEVLOPMENT_ORDER.TESTING.FOR_PREVIEW.PREVIEW_FRAMES')}
        className="w-100 preview-modal-height"
        src={(!isEmpty(previewData?.pdf) || previewData?.pdf !== null) && `${previewData?.pdf}`}
      />
    ) : (
      !Array.isArray(testingAttributes) && (
        <iframe title={t('DEVLOPMENT_ORDER.TESTING.FOR_PREVIEW.PREVIEW_FRAMES')} className="w-100 preview-modal-height" src={testAttri()} />
      )
    );
  };

  const testAttri = () => {
    return (!isEmpty(testingAttributes?.pdf) || testingAttributes?.pdf !== null) && `${testingAttributes?.pdf}`;
  };
  return (
    <Modal
      className="relative-width-modal common-custom-modal modal-medium-4x supplier-overview-modal color-way-modal"
      size="lg"
      show={onOpen}
      onHide={toggle}
      backdrop="static"
    >
      <Modal.Header>
        <Modal.Title>{t('DEVLOPMENT_ORDER.TESTING.FOR_PREVIEW.PREVIEW_TEST_REPORT')}</Modal.Title>
        <span onClick={toggle} className="icon-close cursor-pointer" />
      </Modal.Header>
      <Modal.Body className="px-5">
        {loading && <Loader />}
        {!loading && !previewData && !showData && <div className=" text-center">{t('DEVLOPMENT_ORDER.TESTING.FOR_PREVIEW.NO_PREVIEW_AVAILBLE')}</div>}

        {!loading && (isEmpty(testingAttributes) || testingAttributes === null) && !previewData && (
          <div className=" text-center">{t('DEVLOPMENT_ORDER.TESTING.FOR_PREVIEW.NO_PREVIEW_AVAILBLE')}</div>
        )}
        {!loading && (isEmpty(testingAttributes) || testingAttributes === null) && !showData && (isEmpty(previewData) || previewData === null) && (
          <div className=" text-center">{t('DEVLOPMENT_ORDER.TESTING.FOR_PREVIEW.PREVIEW_TEST_MESSAGE')}</div>
        )}
        {!fromTestLib && !loading && !fromArchive && isEmpty(testingAttributes) && showData && isEmpty(previewData) && Array.isArray(testingAttributes) && (
          <div className=" text-center">{t('DEVLOPMENT_ORDER.TESTING.FOR_PREVIEW.PREVIEW_TEST_MESSAGE')}</div>
        )}
        {renderingData()}
      </Modal.Body>
    </Modal>
  );
}

export default ForPreview;
